module.exports = __webpack_public_path__ + "img/011.05e85b79.jpg";